import { pushEntryIntoQueryArr } from './util';

type GetPaginationQueriesParam<T> = {
  queries?: QueryObj;
  prevData: T[];
  currPage: number;
  sortby?: keyof T | null;
  order?: OrderStatusT;
  targetPage?: number;
  acc?: boolean;
  cursorKey?: keyof T;
};

const getCursorInfoV2 = <T extends { alias: string }>(
  arr: T[],
  sortBy: keyof T,
  aliasKey?: keyof T,
): PaginationCursorsTV2 => {
  const newCursors: PaginationCursorsTV2 = { first: null, last: null };
  if (arr) {
    if (arr.length > 0 && sortBy !== null) {
      ((newCursors.first = arr[0][aliasKey || 'alias'] as string),
        (newCursors.last = arr[arr.length - 1][aliasKey || 'alias'] as string));
    }
  }
  return newCursors;
};

// Pagination V2에 적용되는 pagination query (24.02.28 기준 account, contact, agent 해당)
const getPaginationQueries = <T extends { alias: string }>(
  params: GetPaginationQueriesParam<T>,
): QueryT[] => {
  const {
    queries,
    targetPage,
    currPage,
    prevData,
    sortby,
    order,
    cursorKey,
    acc,
  } = params;

  let direction: 'next' | 'prev' | null = null;
  if (typeof targetPage === 'number') {
    if (targetPage === 0) {
      direction = null;
    } else if (currPage > targetPage) {
      direction = 'prev';
    } else if (currPage <= targetPage) {
      direction = 'next';
    }
  }

  let cursor: string | null = null;

  if (prevData.length > 0) {
    if (direction === 'next') {
      cursor = prevData[prevData.length - 1][cursorKey || 'alias'] as string;
    } else if (direction === 'prev') {
      cursor = prevData[0][cursorKey || 'alias'] as string;
    }
  }

  const paginationQueries = {
    direction: direction || null,
    sortby: sortby as string | null,
    order: order || 'desc',
    cursor: acc ? cursor || null : null,
    ...queries,
  };

  return pushEntryIntoQueryArr([], paginationQueries);
};

export {
  // getCursorInfo,
  // getPaginationQueryValues,
  getCursorInfoV2,
  getPaginationQueries,
};
